import gql from 'graphql-tag'
// import { userProfileFragment } from "@/graphql/user/userProfileFragments";
import { assignmentFragment, assignmentErrorFragment, draftAssignmentFragment } from "@/graphql/assignment/assignmentFragments";
import { tagFragment, customTagFragment, customTagLabelFragment } from '@/graphql/tag/tagFragments'
// import { projectShiftFragment } from '@/graphql/shift/shiftFragments'
import { resourceFragment, resourceTypeFragment, staffVehiculeFragment } from "@/graphql/resource/resourceFragments";


export const ASSIGNMENTSERRORS = gql`
    query assignmentErrors (
        $id: ID
        $projectID: ID
    ){
        assignmentErrors(
            input: {
                id: $id
                projectID: $projectID
            }
        ){
            ...assignmentErrorFragment
            assignments(
                projectID: $projectID
            ){
                ...assignmentFragment
            }
            assignmentAbsence(
                projectID: $projectID
            ){
                ...assignmentFragment
            }
            draftAssignments(
                projectID: $projectID
            ){
                ...draftAssignmentFragment
            }
        }
    }
    ${assignmentErrorFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
`

export const ASSIGNMENTS = gql`
    query assignments (
        $ids: [ID]
        $projectID: ID
        $shiftID: ID
        $notificationID: ID
        $dateRange: activeDuringInputSingleDate
        $date: Date
        $dayOfWeek: Int
        $first: Int = 25
        $page: Int = 1
    ){
        assignments(
            ids: $ids
            projectID: $projectID
            shiftID: $shiftID
            notificationID: $notificationID
            dateRange: $dateRange
            date: $date
            dayOfWeek: $dayOfWeek
            first: $first
            page: $page
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
            }
            data{
                ...assignmentFragment
                assignedTo {
                    # ...userProfileFragment
                    id
                    name
                    email
                }
                profession{
                    ...tagFragment
                }
                shift {
                    id
                    name
                }
                project {
                    id
                    start_date
                    end_date
                    name
                    description
                }
            }
        }
    }
    ${assignmentFragment}
    ${tagFragment}
`
    // ${ userProfileFragment }
    
export const ASSIGNMENTSALL = gql`
    query assignmentsAll (
        $date: Date!
    ){
        assignmentsAll(
            date: $date
        ){
            # data{
                ...assignmentFragment
                assignedTo {
                    # ...userProfileFragment
                    id
                    name
                    email
                }
                profession{
                    ...tagFragment
                }
                shift {
                    name
                    id
                }
                project {
                    id
                    start_date
                    end_date
                    name
                    description
                }
            # }
        }
    }
    ${assignmentFragment}
    ${tagFragment}
`
// ${userProfileFragment}
    
export const DRAFTASSIGNMENTSALL = gql`
    query draftAssignmentsAll (
        $date: Date!
    ){
        draftAssignmentsAll(
            date: $date
        ){
            ...draftAssignmentFragment
            assignedTo {
                # ...userProfileFragment
                id
                name
                email
            }
            profession{
                ...tagFragment
            }
            shift {
                name
                id
            }
            project {
                id
                start_date
                end_date
                name
                description
            }
        }
    }
    ${draftAssignmentFragment}
    ${tagFragment}
`
    // ${userProfileFragment}

export const USERASSIGNMENTS = gql`
    query userAssignments (
        $ids: [ID]
        $projectID: ID
        $userProfileID: ID!
        $shiftID: ID
        $notificationID: ID
        $dateRange: activeDuringInputSingleDate
        $date: Date
        $dayOfWeek: Int
        $first: Int = 25
        $page: Int = 1
        $accepted: Boolean
        $denied: Boolean
        $pending: Boolean
        $includePast: Boolean
    ){
        userAssignments(
            ids: $ids
            projectID: $projectID
            userProfileID: $userProfileID
            shiftID: $shiftID
            notificationID: $notificationID
            dateRange: $dateRange
            date: $date
            dayOfWeek: $dayOfWeek
            first: $first
            page: $page
            accepted: $accepted
            denied: $denied
            pending: $pending
            include_past: $includePast
        ){
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...assignmentFragment
                profession{
                    ...tagFragment
                }
                shift {
                    id
                    name
                }
                project {
                    id
                    name
                }
                projectShift {
                    #...projectShiftFragment
                    id
                    name
                    description
                    courses{
                        ...tagFragment
                    }
                    skills{
                        ...tagFragment
                    }
                    customtags{
                        ...customTagFragment
                        label{
                            ...customTagLabelFragment
                        }
                    }
                    resources{
                        ...resourceFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }
                    staffVehicules{
                        ...staffVehiculeFragment
                        type{
                            ...resourceTypeFragment
                        }
                    }

                }
            }
        }
    }
    ${assignmentFragment}
    ${tagFragment}
    ${customTagFragment}
    ${customTagLabelFragment}
    ${customTagLabelFragment}
    ${resourceTypeFragment}
    ${resourceFragment}
    ${staffVehiculeFragment}
`